import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import classes from "./CustodyChain.module.css";
import { COC_SECOND_TABLE } from "../../constants/constant";
import { getSamplesDataForCOC } from "../../services/samples";

const borderRightBottom =
  "border-r-[black] border-b-[black] border-r border-solid border-b";
const borderRightBottomLeft =
  "border-b-[black] border-x-[black] border-r border-solid border-l border-b";
const verticalWritingContainer =
  "border-t-[black] border-t border-solid flex flex-col justify-end items-center";
const alignColumnCenter = "flex flex-col justify-center items-center";
const alignColumnRight = "flex flex-col justify-center items-end";
const alignColumnLeft = "flex flex-col justify-end items-center";

const firstTableData = (samplesData, threeColumn, firstContainerRowNumber) => {
  // Ensure we always have at least 10 rows
  const minRows = 10;
  const paddedData = [...samplesData];

  // Add empty rows only if we have fewer than 10
  while (paddedData.length < minRows) {
    paddedData.push({
      sampleId: "",
      date: "",
      time: "",
      location: "",
      matrix: "",
      type: "",
      size: "",
      containerType: "",
      preservation: "",
      numContainers1: "",
      epaMethod: "",
      aof: "",
      hrms: "",
      msms: "",
      unknown: "",
      notes: "",
    });
  }

  return paddedData.map((obj, index) => {
    const currentRowNumber = firstContainerRowNumber + index + 1;
    return (
      <React.Fragment key={index + 1}>
        <p
          className={`row-[${currentRowNumber}/_span_1] col-[1/_span_1] ${borderRightBottomLeft} text-center`}
        >
          {index + 1}
        </p>
        <p
          className={`row-[${currentRowNumber}/_span_1] col-[2/_span_1] ${borderRightBottom} pl-[5px]`}
        >
          {obj.sampleId}
        </p>
        <p
          className={`row-[${currentRowNumber}/_span_1] col-[3/_span_1] ${borderRightBottom}`}
        >
          {obj.date}
        </p>
        <p
          className={`row-[${currentRowNumber}/_span_1] col-[4/_span_1] ${borderRightBottom}`}
        >
          {obj.time}
        </p>
        <p
          className={`row-[${currentRowNumber}/_span_1] col-[5/_span_1] ${borderRightBottom}  pl-[5px]`}
        >
          {obj.location}
        </p>
        <p
          className={`row-[${currentRowNumber}/_span_1] col-[6/_span_1] ${borderRightBottom} px-[5px]`}
        >
          {obj.matrix}
        </p>
        <p
          className={`row-[${currentRowNumber}/_span_1] col-[7/_span_1] ${borderRightBottom} px-[5px]`}
        >
          {obj.type}
        </p>
        <p
          className={`row-[${currentRowNumber}/_span_1] col-[8/_span_1] ${borderRightBottom} px-[5px]`}
        >
          {obj.size}
        </p>
        <p
          className={`row-[${currentRowNumber}/_span_1] col-[9/_span_1] ${borderRightBottom} px-[5px]`}
        >
          {obj.containerType}
        </p>
        <p
          className={`row-[${currentRowNumber}/_span_1] col-[10/_span_1] ${borderRightBottom} text-center`}
        >
          {obj.preservation}
        </p>
        <p
          className={`row-[${currentRowNumber}/_span_1] col-[11/_span_1] ${borderRightBottom} text-center`}
        >
          {obj.numContainers1}
        </p>
        <p
          className={`row-[${currentRowNumber}/_span_1] col-[12/_span_1] ${borderRightBottom} text-center`}
        >
          {obj.epaMethod}
        </p>
        <p
          className={`row-[${currentRowNumber}/_span_1] col-[13/_span_1] ${borderRightBottom} text-center`}
        >
          {obj.aof}
        </p>

        {threeColumn ? (
          <>
            <p
              className={`row-[${currentRowNumber}/_span_1] col-[14/_span_1] ${borderRightBottom} text-center`}
            >
              {obj.unknown}
            </p>
            <p
              className={`row-[${currentRowNumber}/_span_1] col-[18/_span_1] ${borderRightBottom} text-[0.5rem]`}
            >
              {obj.notes}
            </p>
          </>
        ) : (
          <>
            <p
              className={`row-[${currentRowNumber}/_span_1] col-[14/_span_1] ${borderRightBottom} text-center`}
            >
              {obj.hrms}
            </p>
            <p
              className={`row-[${currentRowNumber}/_span_1] col-[15/_span_1] ${borderRightBottom} text-center`}
            >
              {obj.msms}
            </p>
            <p
              className={`row-[${currentRowNumber}/_span_1] col-[19/_span_1] ${borderRightBottom} text-[0.5rem]`}
            >
              {obj.notes}
            </p>
          </>
        )}
      </React.Fragment>
    );
  });
};

const secondTableData = (secondContainerRowNumber) =>
  COC_SECOND_TABLE.map((obj) => {
    secondContainerRowNumber += 1;
    return (
      <React.Fragment key={obj.indexId}>
        <p
          className={`row-[${secondContainerRowNumber}/_span_1] col-[1/_span_1] ${borderRightBottomLeft} text-center`}
        >
          {obj.indexId}
        </p>
        <p
          className={`row-[${secondContainerRowNumber}/_span_1] col-[2/_span_3] ${borderRightBottom}`}
        >
          {obj.relNameAgency}
        </p>
        <p
          className={`row-[${secondContainerRowNumber}/_span_1] col-[5/_span_1] ${borderRightBottom}`}
        >
          {obj.relSignature}
        </p>
        <p
          className={`row-[${secondContainerRowNumber}/_span_1] col-[6/_span_1] ${borderRightBottom}`}
        >
          {obj.relDate}
        </p>
        <p
          className={`row-[${secondContainerRowNumber}/_span_1] col-[7/_span_1] ${borderRightBottom}`}
        >
          {obj.relTime}
        </p>
        <p
          className={`row-[${secondContainerRowNumber}/_span_1] col-[8/_span_3] ${borderRightBottom}`}
        >
          {obj.recNameAgency}
        </p>
        <p
          className={`row-[${secondContainerRowNumber}/_span_1] col-11/_span_1] ${borderRightBottom}`}
        >
          {obj.relSignature}
        </p>
        <p
          className={`row-[${secondContainerRowNumber}/_span_1] col-[12/_span_1] ${borderRightBottom}`}
        >
          {obj.relDate}
        </p>
        <p
          className={`row-[${secondContainerRowNumber}/_span_1] col-[13/_span_1] ${borderRightBottom}`}
        >
          {obj.relTime}
        </p>
      </React.Fragment>
    );
  });

const kitMapping = {
  KIT_: "_",
  KITA: "A",
  KITB: "B",
  KITC: "C",
  KITD: "D",
  KITE: "E",
  KITF: "F",
  KITG: "G",
};

const Custody_Chain = () => {
  let { visitId, kit, pwsname } = useParams();

  const [samplesData, setSamplesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Decode URL-encoded parameters
  if (pwsname) pwsname = decodeURIComponent(pwsname);

  kit = kit.replace(" ", "").toUpperCase();
  const threeColumn = kit === "KITA" || kit === "KITB" || kit === "KITE";

  let firstContainerRowNumber = 8;
  let secondContainerRowNumber = 2;

  useEffect(() => {
    if (!visitId) {
      setIsLoading(false);
      return;
    }

    const fetchSamplesData = async () => {
      try {
        setIsLoading(true);
        const response = await getSamplesDataForCOC(visitId);

        if (response.status === 1) {
          setSamplesData(response.data);
          setError(null);
        } else {
          setError(response.message || "Failed to fetch samples data");
        }
      } catch (err) {
        setError("An error occurred while fetching samples data");
        console.error("Error fetching samples:", err);
      } finally {
        setIsLoading(false);
      }
    };

    if (visitId) {
      fetchSamplesData();
    }

    return () => {
      firstContainerRowNumber = 8;
      secondContainerRowNumber = 2;
    };
  }, [visitId]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading...
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen text-red-500">
        Error: {error}
      </div>
    );
  }

  return (
    <div className={classes.mainContainer}>
      <div
        className={`${classes.firstContainer} ${threeColumn ? classes.threeColumn : classes.fourColumn
          }`}
      >
        {/* start of the first group */}
        <div
          className={`row-[1/_span_1] col-[1/_span_3] ${borderRightBottomLeft} border-t-[black] border-t border-solid px-[5px]`}
        >
          <b>Sample Collection Agency:</b>
          <p>State Water Board DDW</p>
        </div>
        <div
          className={`row-[2/_span_1] col-[1/_span_3] ${borderRightBottomLeft} px-[5px]`}
        >
          <b>Sample Collection Agency Address:</b>
          <p>1001 | Street, Sacramento, CA 95814</p>
        </div>
        <div
          className={`row-[3/_span_1] col-[1/_span_3] ${borderRightBottomLeft} px-[5px]`}
        >
          <b>PWS Name: </b>
          <p>{pwsname}</p>
        </div>
        <div
          className={`row-[4/_span_1] col-[1/_span_3] ${borderRightBottomLeft} px-[5px]`}
        >
          <b>Project Lead: </b>
        </div>
        <div
          className={`row-[5/_span_1] col-[1/_span_3] ${borderRightBottomLeft} px-[5px]`}
        >
          <p style={{ paddingLeft: "5px" }}> Name: Wendy Linck</p>
        </div>
        <div
          className={`row-[6/_span_1] col-[1/_span_3] ${borderRightBottomLeft} px-[5px]`}
        >
          <p style={{ paddingLeft: "5px" }}> Phone: (916) 323-0888</p>
        </div>
        <div
          className={`row-[7/_span_1] col-[1/_span_3] ${borderRightBottomLeft} px-[5px]`}
        >
          <p style={{ paddingLeft: "5px" }}>
            Email: wendy.linck@waterboards.ca.gov
          </p>
        </div>
        {/* end of first group */}
        {/* start of the table */}
        <b
          className={`row-[8/_span_1] col-[1/_span_1] ${borderRightBottomLeft} text-center bg-[#eaeaea]`}
        />
        <b
          className={`row-[8/_span_1] col-[2/_span_1] ${borderRightBottom} text-center bg-[#eaeaea]`}
        >
          Sample Id
        </b>
        <b
          className={`row-[8/_span_1] col-[3/_span_1] ${borderRightBottom} text-center bg-[#eaeaea]`}
        >
          Date
        </b>
        <b
          className={`row-[8/_span_1] col-[4/_span_1] ${borderRightBottom} text-center bg-[#eaeaea]`}
        >
          Time
        </b>
        <b
          className={`row-[8/_span_1] col-[5/_span_1] ${borderRightBottom} text-center bg-[#eaeaea]`}
        >
          Location
        </b>

        {firstTableData(samplesData, threeColumn, firstContainerRowNumber)}

        <b
          className={`row-[9/_span_10] ${threeColumn ? "col-[15/_span_1]" : "col-[16/_span_1]"
            } ${borderRightBottom}`}
        />
        <b
          className={`row-[9/_span_10] ${threeColumn ? "col-[16/_span_1]" : "col-[17/_span_1]"
            } ${borderRightBottom}`}
        />
        <b
          className={`row-[9/_span_10] ${threeColumn ? "col-[17/_span_1]" : "col-[18/_span_1]"
            } ${borderRightBottom}`}
        />

        {/* end of table */}
        {/* start of the second group */}

        <div
          className={`row-[1/_span_1] col-[4/_span_2] ${borderRightBottom} border-t-[black] border-t border-solid px-[5px]`}
        >
          <b>Agreement No:</b>
          <p>23-035-270</p>
        </div>
        <div
          className={`row-[2/_span_1] col-[4/_span_2] ${borderRightBottom} px-[5px]`}
        >
          <b>Project Codes:</b>
          <p>PFASDAC2024SamplingEvent</p>
          <p>PFASDAC2025SamplingEvent</p>
        </div>
        <div
          className={`row-[3/_span_1] col-[4/_span_2] ${borderRightBottom} px-[5px]`}
        >
          <b>Project Name:</b>
          <p> PFAS DAC Well Sampling</p>
        </div>
        <div
          className={`row-[4/_span_1] col-[4/_span_2] ${borderRightBottom} px-[5px]`}
        >
          <b>Field Lead: </b>
        </div>
        <div
          className={`row-[5/_span_1] col-[4/_span_2] ${borderRightBottom} px-[5px]`}
        >
          <p style={{ paddingLeft: "5px" }}> Name:</p>
        </div>
        <div
          className={`row-[6/_span_1] col-[4/_span_2] ${borderRightBottom} px-[5px]`}
        >
          <p style={{ paddingLeft: "5px" }}> Phone: </p>
        </div>
        <div
          className={`row-[7/_span_1] col-[4/_span_2] ${borderRightBottom} px-[5px]`}
        >
          <p style={{ paddingLeft: "5px" }}>Email:</p>
        </div>

        {/* end of the second group */}

        <div
          className={`row-[1/_span_8] col-[6/_span_1] thirdGroup ${borderRightBottom} border-t-[black] ${verticalWritingContainer} py-[5px]`}
        >
          <p className={`${classes.verticalWriting} text-[0.72em]`}>
            &nbsp;(See Codes Below)
          </p>
          <b className={classes.verticalWriting}>Sample Matrix</b>
        </div>
        <div
          className={`row-[1/_span_8] col-[7/_span_1] thirdGroup ${borderRightBottom} ${verticalWritingContainer} py-[5px]`}
        >
          <p className={`${classes.verticalWriting} text-[0.72em]`}>
            &nbsp;(G = Grab; C = Composite; O = Other)
          </p>
          <b className={classes.verticalWriting}>Sample Type</b>
        </div>
        <div
          className={`row-[1/_span_8] col-[8/_span_1] ${borderRightBottom} ${verticalWritingContainer} py-[5px]`}
        >
          <p className={`${classes.verticalWriting} text-[0.72em]`}>
            &nbsp;(ml)
          </p>
          <b className={classes.verticalWriting}>Container Size</b>
        </div>
        <div
          className={`row-[1/_span_8] col-[9/_span_1] ${borderRightBottom} ${verticalWritingContainer} py-[5px]`}
        >
          <p className={`${classes.verticalWriting} text-[0.72em]`}>
            &nbsp;(P = Plastic; G = Glass; O = Other)
          </p>
          <b className={classes.verticalWriting}>Container Type</b>
        </div>
        <div
          className={`row-[1/_span_8] col-[10/_span_1] ${borderRightBottom} ${verticalWritingContainer} py-[5px]`}
        >
          <p className={`${classes.verticalWriting} text-[0.72em]`}>
            &nbsp;(See the Codes Below)
          </p>
          <b className={classes.verticalWriting}>Preservation Code</b>
        </div>
        <div
          className={`row-[1/_span_8] col-[11/_span_1] ${borderRightBottom} ${verticalWritingContainer} py-[5px]`}
        >
          <b className={classes.verticalWriting}># of Containers</b>
        </div>

        <b
          className={`row-[1/_span_1] ${threeColumn ? "col-[12/_span_3]" : "col-[12/_span_4]"
            } ${borderRightBottom} border-t-[black] border-t border-solid ${alignColumnCenter} bg-[#eaeaea]`}
        >
          Analyses Requested
        </b>
        <div
          className={`row-[2/_span_7] col-[12/_span_1] ${borderRightBottom} ${alignColumnLeft} ${verticalWritingContainer.split(" ")[1]
            } py-[5px]`}
        >
          <b className={classes.verticalWriting}>EPA Method 533</b>
        </div>
        <div
          className={`row-[2/_span_7] col-[13/_span_1] ${borderRightBottom} ${alignColumnLeft} ${verticalWritingContainer.split(" ")[1]
            } py-[5px]`}
        >
          <b className={classes.verticalWriting}>AOF-CIC</b>
        </div>
        <div
          className={`row-[2/_span_7] col-[14/_span_1] ${borderRightBottom} ${alignColumnLeft} ${verticalWritingContainer.split(" ")[1]
            } py-[5px]`}
        >
          <b className={classes.verticalWriting}>
            {threeColumn ? "" : "LC-HRMS DoD QSM extract"}
          </b>
        </div>
        {!threeColumn && (
          <div
            className={`row-[2/_span_7] col-[15/_span_1] ${borderRightBottom} flex flex-row py-[5px]`}
          >
            <b className={classes.verticalWriting}>IC-MSMS – DoD extract</b>
            <p className={classes.verticalWriting}>
              (TFA, PFPrA, TFMS, PFEtS, PFPrS, Bistrif, PF6)
            </p>
          </div>
        )}

        <b
          className={`row-[1/_span_1] ${threeColumn ? "col-[15/_span_3]" : "col-[16/_span_3]"
            } ${borderRightBottom} border-t-[black] border-t border-solid text-[0.5rem] bg-[#eaeaea] text-center py-[5px]`}
        >
          Field Quality Meter Readings (last measurement before sample
          collection)
        </b>
        <div
          className={`row-[2/_span_7] ${threeColumn ? "col-[15/_span_1]" : "col-[16/_span_1]"
            } ${borderRightBottom} ${alignColumnLeft} py-[5px]`}
        >
          <p className={`${classes.verticalWriting} text-[0.72em]`}>
            &nbsp;(unitless)
          </p>
          <b className={classes.verticalWriting}>pH</b>
        </div>
        <div
          className={`row-[2/_span_7] ${threeColumn ? "col-[16/_span_1]" : "col-[17/_span_1]"
            } ${borderRightBottom} ${alignColumnLeft} py-[5px]`}
        >
          <p className={`${classes.verticalWriting} text-[0.72em]`}>
            &nbsp;(µS)
          </p>
          <b className={classes.verticalWriting}>Conductivity</b>
        </div>
        <div
          className={`row-[2/_span_7] ${threeColumn ? "col-[17/_span_1]" : "col-[18/_span_1]"
            } ${borderRightBottom} ${alignColumnLeft} py-[5px]`}
        >
          <p className={`${classes.verticalWriting} text-[0.72em]`}>
            &nbsp;(NTU)
          </p>
          <b className={classes.verticalWriting}>Turbidity</b>
        </div>

        <b
          className={`row-[1/_span_1] ${threeColumn ? "col-[18/_span_1]" : "col-[19/_span_1]"
            } ${borderRightBottom} border-t-[black] border-t border-solid ${alignColumnCenter} bg-[#eaeaea]`}
        >
          KIT&nbsp;{kitMapping[kit]}
        </b>
        <div
          className={`row-[2/_span_7] ${threeColumn ? "col-[18/_span_1]" : "col-[19/_span_1]"
            } ${borderRightBottom} flex flex-col justify-between items-center`}
        >
          <b>Page 1 of 1</b>
          <b>Notes</b>
        </div>
      </div>
      <div className={classes.secondContainer}>
        {/* header */}
        <b
          className={`col-[1/_span_7] ${borderRightBottomLeft} bg-[#eaeaea] pl-[5px]`}
        >
          Samples Relinquished By:
        </b>
        <b
          className={`col-[8/_span_6] ${borderRightBottom} bg-[#eaeaea] pl-[5px]`}
        >
          Samples Received By:
        </b>
        {/* subheader */}
        <b
          className={`row-[2/_span_1] col-[1/_span_1] ${borderRightBottomLeft} ${alignColumnCenter}`}
        />
        <b
          className={`row-[2/_span_1] col-[2/_span_3] ${borderRightBottom} ${alignColumnCenter}`}
        >
          Name(Print) and Agent
        </b>
        <b
          className={`row-[2/_span_1] col-[5/_span_1] ${borderRightBottom} ${alignColumnCenter}`}
        >
          Signature
        </b>
        <b
          className={`row-[2/_span_1] col-[6/_span_1] ${borderRightBottom} ${alignColumnCenter}`}
        >
          Date
        </b>
        <b
          className={`row-[2/_span_1] col-[7/_span_1] ${borderRightBottom} ${alignColumnCenter}`}
        >
          Time
        </b>
        <b
          className={`row-[2/_span_1] col-[8/_span_3] ${borderRightBottom} ${alignColumnCenter}`}
        >
          Name(Print) and Agent
        </b>
        <b
          className={`row-[2/_span_1] col-[11/_span_1] ${borderRightBottom} ${alignColumnCenter}`}
        >
          Signature
        </b>
        <b
          className={`row-[2/_span_1] col-[12/_span_1] ${borderRightBottom} ${alignColumnCenter}`}
        >
          Date
        </b>
        <b
          className={`row-[2/_span_1] col-[13/_span_1] ${borderRightBottom} ${alignColumnCenter} px-[5px]`}
        >
          Time
        </b>

        {/* data */}
        {secondTableData(secondContainerRowNumber)}

        {/* subheader */}
        <b
          className={`row-[7/_span_1] col-[1/_span_2] ${borderRightBottomLeft} bg-[#eaeaea] ${alignColumnCenter}`}
        >
          Sample Matrix
        </b>
        <b
          className={`row-[7/_span_1] col-[3/_span_1] ${borderRightBottom} bg-[#eaeaea] ${alignColumnCenter}`}
        >
          Preservation Codes
        </b>
        <b
          className={`row-[7/_span_1] col-[4/_span_5] ${borderRightBottom} bg-[#eaeaea] ${alignColumnCenter}`}
        >
          Sample Receipt- Completed by Laboratory personnel:
        </b>
        <b
          className={`row-[7/_span_1] col-[9/_span_2] ${borderRightBottom} bg-[#eaeaea] ${alignColumnCenter}`}
        >
          Laboratory Notes:
        </b>
        <b
          className={`row-[7/_span_1] col-[11/_span_3] ${borderRightBottom} bg-[#eaeaea] ${alignColumnCenter}`}
        >
          Special Instructions
        </b>
        {/* data 1 */}
        <div className={`row-[8/-1] col-[1/_span_2] ${borderRightBottomLeft}`}>
          <ul className="text-[0.45rem] p-0.5">
            <li>SFW = Surface Fresh Water;</li>
            <li>SSW = Surface Salt Water;</li>
            <li>DW = Drinking Water;</li>
            <li>GW = Ground Water;</li>
            <li>SW = Storm Water;</li>
            <li>WW = Wash Water;</li>
            <li>OL = Other Liquids;</li>
            <li>SO = Soil / Sediment;;</li>
            <li>SL = Sludge / Slumy;</li>
            <li>OS = Other Solids;</li>
            <li>O = Other</li>
            <li>
              <hr className="ml-[15px] mr-[35px] my-[5px]" />
            </li>
          </ul>
        </div>
        {/* data 2*/}
        <div className={`row-[8/-1] col-[3/_span_1] ${borderRightBottom}`}>
          <ol className="text-[0.45rem] p-0.5">
            <li>1. Cool, &lt; 6 &deg;C; </li>
            <li>2. HNO3</li>
            <li>3. HCL</li>
            <li>4. H2SO4</li>
            <li>5. Na2S2O3</li>
            <li>6. NaOH</li>
            <li>7. NaOH/ZnAcetate</li>
            <li>8. NH4CL</li>
            <li>9. Trizma</li>
            <li>10. Filtered</li>
            <li>11. Freeze, &lt; -10 &deg;C</li>
            <li>12. None required</li>
            <li>13. Other</li>
            <li>
              <hr className="ml-[15px] mr-[55px] my-[5px]" />
            </li>
          </ol>
        </div>
        {/* data 3 */}
        <p
          className={`row-[8/_span_1] col-[4/_span_4] ${borderRightBottom} ${alignColumnRight} pr-2.5`}
        >
          Total Number of Sample Containers Received:
        </p>
        <p
          className={`row-[9/_span_1] col-[4/_span_4]  border-r-[black] border-r border-solid; ${alignColumnRight} pr-2.5`}
        >
          Sample(s) Properly Cooled: Y / N / NA
        </p>
        <p
          className={`row-[10/_span_1] col-[4/_span_4] ${borderRightBottom} ${alignColumnRight} pr-2.5`}
        >
          Temperature (&deg;C):
        </p>
        <p
          className={`row-[11/_span_1] col-[4/_span_4] ${borderRightBottom} ${alignColumnRight} pr-2.5`}
        >
          Sample(s) Intact: Y / N / NA
        </p>
        <p
          className={`row-[12/_span_1] col-[4/_span_4] ${borderRightBottom} ${alignColumnRight} pr-2.5`}
        >
          Custody Seal(s) Intact: Y / N / NA
        </p>
        <p
          className={`row-[13/_span_1] col-[4/_span_4] ${borderRightBottom} ${alignColumnRight} pr-2.5`}
        >
          Sample(s) Accepted: Y / N
        </p>
        {/* data 4 */}
        <p className={`row-[8/_span_1] col-[8/_span_1] ${borderRightBottom}`} />
        <p className={`row-[9/_span_1] col-[8/_span_1] ${borderRightBottom}`} />
        <p
          className={`row-[10/_span_1] col-[8/_span_1] ${borderRightBottom}`}
        />
        <p
          className={`row-[11/_span_1] col-[8/_span_1] ${borderRightBottom}`}
        />
        <p
          className={`row-[12/_span_1] col-[8/_span_1] ${borderRightBottom}`}
        />
        <p
          className={`row-[13/_span_1] col-[8/_span_1] ${borderRightBottom}`}
        />
        {/* data 5 */}
        <p
          className={`row-[8/_span_4] col-[9/_span_2] ${borderRightBottom}`}
        ></p>
        <b
          className={`row-[12/_span_2] col-[9/_span_1] ${borderRightBottom} ${alignColumnRight} pl-[5px]`}
        >
          Send Results to:
        </b>
        <p
          className={`row-[12/_span_1] col-[10/_span_1] ${borderRightBottom} pl-[5px]`}
        >
          Project FTP site
          <br />
          (https://ftp.waterboards.ca.gov)
        </p>
        <p
          className={`row-[13/_span_1] col-[10/_span_1] ${borderRightBottom}`}
        />
        {/* data 6 */}
        <p
          className={`row-[8/_span_1] col-[11/_span_2] ${borderRightBottom} pl-[5px]`}
        >
          Evidence sample handling required?
        </p>
        <p
          className={`row-[9/_span_1] col-[11/_span_2] ${borderRightBottom} pl-[5px]`}
        >
          Return Shipping Containers?
        </p>
        <b
          className={`row-[10/-1] col-[11/_span_1] ${borderRightBottom}  ${alignColumnCenter} pl-[5px]`}
        >
          Turn Around Time:
        </b>
        <p
          className={`row-[10/_span_2] col-[12/_span_1] ${borderRightBottom} pl-[5px]`}
        >
          Routine
        </p>
        <p
          className={`row-[12/_span_1] col-[12/_span_1] ${borderRightBottom} pl-[5px]`}
        >
          *3-5 Day (Rush)
        </p>
        <p
          className={`row-[13/_span_1] col-[12/_span_1] ${borderRightBottom} pl-[5px]`}
        >
          *48-Hr (Rush)
        </p>
        {/* data 7 */}
        <div
          className={`row-[8/_span_1] col-[13/_span_1] ${borderRightBottom} ${alignColumnCenter}`}
        >
          <input type="checkbox" />
        </div>
        <div
          className={`row-[9/_span_1] col-[13/_span_1] ${borderRightBottom}  ${alignColumnCenter}`}
        >
          <input type="checkbox" />
        </div>
        <div
          className={`row-[10/_span_2] col-[13/_span_1] ${borderRightBottom}  ${alignColumnCenter}`}
        >
          <input type="checkbox" />
        </div>
        <div
          className={`row-[12/_span_1] col-[13/_span_1] ${borderRightBottom}  ${alignColumnCenter}`}
        >
          <input type="checkbox" />
        </div>
        <div
          className={`row-[13/_span_1] col-[13/_span_1] ${borderRightBottom}  ${alignColumnCenter}`}
        >
          <input type="checkbox" />
        </div>
      </div>
    </div>
  );
};
export default Custody_Chain;
